// extracted by mini-css-extract-plugin
export default {"wrapper":"Stacked_wrapper__+OPHg","child":"Stacked_child__xWQ6g","count":"Stacked_count__eFKzj"};